import React from 'react';
import { Link } from 'gatsby';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { v4 as uuidv4 } from 'uuid';
import Img from 'gatsby-image';

import ListMobilStyle from '../styles/ListMobilStyle';
import TextBlockInfo from './TextBlockAbout';

export default function ListMobil({ pageContent, location }) {
  const dataToInsert = pageContent.props.data.queryPage.nodes;
  const urlPath = pageContent.props.uri;
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const checkPage = () => {
    if (/realisation/.test(urlPath)) {
      return 'Realisations';
    }
    if (/etude/.test(urlPath)) {
      return 'Etudes';
    }
    if (/actu/.test(urlPath)) {
      return 'Actualites';
    }
 
    if (/contact/.test(urlPath)) {
      return 'Contact';
    } 

    if (/colophon/.test(urlPath)) {
      return 'Colophon';
    }
    if (/biographie/.test(urlPath)) {
      return 'Biographie';
    }
    if (/cv/.test(urlPath)) {
      return 'Cv';
    }
  };

  const pageType = checkPage();

  return (
    <ListMobilStyle>
      <h2>{pageType}</h2>
      {pageType === 'Contact' || pageType === 'Colophon' || pageType === 'Biographie' || pageType === 'Cv' ? (
    <TextBlockInfo data={pageContent.props.data.queryPage.nodes[0]}  />
      ) : (
        dataToInsert.map((node) => (
          <Link to={`/${pageType.toLowerCase()}/${node.slug.current}`} key={uuidv4()}>
            <div className="listbox">
              <Slider {...settings}>
                {node.images &&
                  node.images.map(
                    (image) =>
                      image.asset && (
                        <Img
                          fluid={image.asset.fluid}
                          key={uuidv4()}
                          alt={node.name}
                        />
                      )
                  )}
              </Slider>
              <h3>
                {node.date} {node.name} {node.place ? `/ ${node.place}` : ''}
              </h3>
            </div>
          </Link>
        ))
      )}
    </ListMobilStyle>
  );
}
